import { useMemo } from 'react';
import { Flex, Stack, Text } from '@mantine/core';
import CustomLoadingOverlay from '@/components/CustomLoadingOverlay.tsx';
import useRetrieveAutomationTriggerDatasets from '@/hooks/api/datasets/trigger/useRetrieveAutomationTriggerDatasets.ts';
import { ManualTriggerInput, ManualTriggerInputType } from '@/types/automationSteps.ts';
import { DatasetType } from '@/types/automationFields.ts';
import { isDirectory } from '@/utils/datasetTypes.ts';
import PreviouslyUploadedFile from '@/pages/AutomationPage/components/ManualRunModal/components/PreviouslyUploadedFiles/PreviouslyUploadedFile.tsx';

type props = {
  automationId?: string;
  manualTrigger: ManualTriggerInput;
  selectedExistingDatasetId?: string;
  setSelectedExistingDatasetId: (id: string) => void;
  // datasetName: string;
  // setDatasetName: Dispatch<SetStateAction<string>>;
};

const PreviouslyUploadedFiles = ({
  automationId,
  manualTrigger,
  selectedExistingDatasetId,
  setSelectedExistingDatasetId,
  // datasetName,
  // setDatasetName,
}: props) => {
  const { data: triggerDatasets, isPending: loadingManualRunDatasets } =
    useRetrieveAutomationTriggerDatasets(automationId);

  const filteredDatasets = useMemo(() => {
    if (!triggerDatasets?.results) return [];
    if (manualTrigger.input_type === ManualTriggerInputType.Folder) {
      return triggerDatasets.results.filter(
        (d) => isDirectory(d.dataset) && d.trigger_id === manualTrigger.output_id,
      );
    } else {
      return triggerDatasets.results.filter(
        (d) =>
          !isDirectory(d.dataset) &&
          d.trigger_id === manualTrigger.output_id &&
          (manualTrigger.input_type !== ManualTriggerInputType.Json ||
            d.dataset.dataset_type === DatasetType.Json),
      );
    }
  }, [manualTrigger, triggerDatasets]);

  return (
    <Stack
      style={{
        border: '1px solid #ECECED',
        borderRadius: '4px',
        padding: '4px',
        overflowY: 'auto',
        position: 'relative',
      }}
      gap={'1px'}
      mah={'140px'}
      mih={'140px'}
    >
      <CustomLoadingOverlay visible={loadingManualRunDatasets} />

      {filteredDatasets.map((d) => (
        <PreviouslyUploadedFile
          triggerDataset={d}
          key={d.id}
          selectedExistingDatasetId={selectedExistingDatasetId}
          setSelectedExistingDatasetId={setSelectedExistingDatasetId}
        />
      ))}
      {filteredDatasets?.length === 0 && (
        <Flex
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        >
          <Text style={{ whiteSpace: 'nowrap' }} c={'dimmed'}>
            There are no existing{' '}
            {manualTrigger.input_type === ManualTriggerInputType.Folder
              ? 'folders'
              : manualTrigger.input_type === ManualTriggerInputType.Json
                ? 'JSON inputs'
                : 'files'}
          </Text>
        </Flex>
      )}
    </Stack>
  );
};

export default PreviouslyUploadedFiles;
